var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-tooltip",
    {
      attrs: { "open-delay": "300", top: "", disabled: _vm.isLocal },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on }) {
            return [
              _c("v-autocomplete", {
                ref: "field",
                attrs: {
                  value: _vm.value,
                  label: _vm.isLocal ? undefined : "Taxonomic filter",
                  placeholder: _vm.isLocal
                    ? "Search scientific name"
                    : "Start typing scientific name to search",
                  "hide-no-data": !_vm.isLocal,
                  "no-data-text": "No matching taxon in the hits",
                  items: _vm.isLocal ? _vm.localItems : _vm.items,
                  loading: _vm.isLoading,
                  "search-input": _vm.search,
                  "return-object": "",
                  "auto-select-first": "",
                  "allow-overflow": false,
                  dense: "",
                  chips: !_vm.isLocal,
                  "deletable-chips": !_vm.isLocal,
                  outlined: _vm.isLocal,
                  "hide-details": _vm.isLocal,
                  clearable: _vm.isLocal,
                  "prepend-inner-icon": _vm.isLocal
                    ? _vm.$MDI.Magnify
                    : undefined,
                  "menu-props": _vm.localMenuProps,
                },
                on: {
                  "update:searchInput": function ($event) {
                    _vm.search = $event
                  },
                  "update:search-input": function ($event) {
                    _vm.search = $event
                  },
                  input: _vm.change,
                  focus: _vm.fitBelow,
                  click: _vm.fitBelow,
                },
                scopedSlots: _vm._u(
                  [
                    _vm.isLocal
                      ? {
                          key: "item",
                          fn: function ({ item }) {
                            return [
                              _c(
                                "v-list-item-content",
                                [
                                  _c("v-list-item-title", [
                                    _vm._v(_vm._s(item.text)),
                                  ]),
                                  _vm._v(" "),
                                  _c("v-list-item-subtitle", [
                                    _vm._v(
                                      _vm._s(
                                        [
                                          item.rank,
                                          item.count +
                                            (item.count == 1
                                              ? " hit"
                                              : " hits"),
                                        ]
                                          .filter(Boolean)
                                          .join(" · ")
                                      )
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ]
                          },
                        }
                      : null,
                  ],
                  null,
                  true
                ),
              }),
            ]
          },
        },
      ]),
    },
    [_vm._v(" "), _c("span", [_vm._v("Restrict results to taxonomic clade")])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }